ko.bindingHandlers.observe = {
    init: (element, valueAccessor) => {
        var modelValue = valueAccessor(),
            unwrappedValue = ko.utils.peekObservable(modelValue);

        if (unwrappedValue.intersect)
        {
            let callback = (entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        let el = entry.target;
                        observer.unobserve(el);

                        var item = ko.dataFor(el);
                        if (typeof item != 'undefined') {
                            unwrappedValue.intersect(item, entry);
                        }
                    }
                })
            };

            let options = {
                root: null,
                rootMargin: '100px',
            };

            let observer = new IntersectionObserver(callback, options);

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                observer.disconnect();
            });

            ko.bindingEvent.subscribe(element, 'childrenComplete', () => {
                var selector = unwrappedValue['selector'];
                var elements = element.querySelectorAll(selector);

                elements.forEach(el => observer.observe(el));
            });
        }

        if (unwrappedValue.watch && ko.isObservable(unwrappedValue.watch)) {
            unwrappedValue.watch.subscribe(changes => {
                
            }, null, "arrayChange");
        }

        return { 'controlsDescendantBindings': false };
    }
}